import * as React from "react"
import { useLocation } from "react-router-dom"

const useAppNavigation = () => {
  const location = useLocation()

  const appInstanceId = new URLSearchParams(location.search).get("app_instance_id")
  if (appInstanceId === null) throw new Error("Missing app_instance_id")

  const withAppInstanceId = React.useCallback((to: string) => `${to}?app_instance_id=${appInstanceId}`, [appInstanceId])

  return {
    appInstanceId,
    withAppInstanceId,
  }
}

export default useAppNavigation
